// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Xk-Yz","colMin":"styles_colMin__oFS2q"};